export const insert = <T>(arr: T[], index: number, newItem: T): T[] => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
];

export const remove = <T>(array: T[], index: number): T[] => (
    array.slice(0, index).concat(array.slice(index + 1, array.length))
);

export const sortByOrder = <T, K extends keyof T>(array: Array<T>, order: Array<T[K] | T>, key?: K): Array<T> => {
    return array.sort( ( a: T, b: T ): number => {
        const A = key ? a[key] : a;
        const B = key ? b[key] : b;
        let indexA: number = order.indexOf(A);
        let indexB: number = order.indexOf(B);
        if (indexA === -1) {
            indexA = order.length;
        }
        if (indexB === -1) {
            indexB = order.length;
        }
        if (indexA > indexB) {
            return 1;
        } else {
            return -1;
        }
    });
};
